import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalMentions.css';

const LegalMentions = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-mentions">
      <section className="legal-hero section">
        <div className="legal-header">
          <h1>{t('legal.title')}</h1>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <div className="legal-section glass-card">
            <p className="legal-intro">{t('legal.intro')}</p>
            
            <h2>{t('legal.editor.title')}</h2>
            <p>{t('legal.editor.description')}</p>
            <p>{t('legal.editor.company')}</p>
            <p>{t('legal.editor.contact')}: contact@odyssey-technology.com</p>
            <p>{t('legal.editor.phone')}: +33169047286</p>
          </div>

          <div className="legal-section glass-card">
            <h2>{t('legal.dataProcessing.title')}</h2>
            <p>{t('legal.dataProcessing.paragraph1')}</p>
            <p>{t('legal.dataProcessing.paragraph2')}</p>
            <p>{t('legal.dataProcessing.paragraph3')}</p>
          </div>

          <div className="legal-section glass-card">
            <h2>{t('legal.cookies.title')}</h2>
            <p>{t('legal.cookies.paragraph1')}</p>
            <p>{t('legal.cookies.paragraph2')}</p>
            <p>{t('legal.cookies.paragraph3')}</p>
          </div>

          <div className="legal-section glass-card">
            <h2>{t('legal.dataRetention.title')}</h2>
            <p>{t('legal.dataRetention.content')}</p>
          </div>

          <div className="legal-section glass-card">
            <h2>{t('legal.phoneMarketing.title')}</h2>
            <p>{t('legal.phoneMarketing.paragraph1')}</p>
            <p>{t('legal.phoneMarketing.paragraph2')}</p>
          </div>

          <div className="legal-section glass-card">
            <h2>{t('legal.rights.title')}</h2>
            <p>{t('legal.rights.intro')}</p>
            <ul className="legal-list">
              <li>{t('legal.rights.item1')}</li>
              <li>{t('legal.rights.item2')}</li>
              <li>{t('legal.rights.item3')}</li>
              <li>{t('legal.rights.item4')}</li>
              <li>{t('legal.rights.item5')}</li>
              <li>{t('legal.rights.item6')}</li>
              <li>{t('legal.rights.item7')}</li>
            </ul>
            <p>{t('legal.rights.conclusion')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalMentions;